import React from "react";
import { Helmet } from "react-helmet";
import { s3BaseURL } from "../../utils/constantInformation";

function AppCSS() {
  return (
    <>
      <Helmet>
        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href={s3BaseURL + "res/favicon/apple-icon-57x57.png"}
        />
        <link
          rel="apple-touch-icon"
          sizes="60x60"
          href={s3BaseURL + "res/favicon/apple-icon-60x60.png"}
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href={s3BaseURL + "res/favicon/apple-icon-72x72.png"}
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href={s3BaseURL + "res/favicon/apple-icon-76x76.png"}
        />
        <link rel="apple-touch-icon" sizes="114x114" href="res/favicon" />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href={s3BaseURL + "res/favicon/apple-icon-120x120.png"}
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href={s3BaseURL + "res/favicon/apple-icon-144x144.png"}
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href={s3BaseURL + "res/favicon/apple-icon-152x152.png"}
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={s3BaseURL + "res/favicon/apple-icon-180x180.png"}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href={s3BaseURL + "res/favicon/android-icon-192x192.png"}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={s3BaseURL + "res/favicon/favicon-32x32.png"}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href={s3BaseURL + "res/favicon/favicon-96x96.png"}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={s3BaseURL + "res/favicon/favicon-16x16.png"}
        />
        <link rel="manifest" href="res/favicon/manifest.json" />

        <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"
        />
        <link rel="stylesheet" href="app/css/style.css" />
      </Helmet>
    </>
  );
}

export default AppCSS;
